import { call, put, takeLatest } from 'redux-saga/effects';
import { YieldOf } from 'types/utils';
import { Constants } from 'core';

import {
  createSituation,
  createdSituation,
  updateSituation,
  updatedSituation,
  deleteSituation,
  deletedSituation,
} from './actions';
import { fetchSituations } from '../situations/actions';
import { logout } from '../api-auth/actions';
import getAPI from '../../api/iv-back';
import { sagaWithCallback } from '../utils';

type CreateSituationActionPayload = ReturnType<typeof createSituation>;
type UpdateSituationActionPayload = ReturnType<typeof updateSituation>;
type DeleteSituationActionPayload = ReturnType<typeof deleteSituation>;

export function* createSituationSaga({ payload }: CreateSituationActionPayload) {
  const { createSituationApi } = getAPI();
  const response: YieldOf<typeof createSituationApi> = yield call(createSituationApi, payload);
  const { data, ok, problem, status } = response;
  if (status === 401 || status === 403) {
    yield put(logout());
  }
  if (ok) {
    yield put(fetchSituations());
    yield put(createdSituation(data));
    return data;
  } else {
    const error =
      status === Constants.ALREADY_EXISTED_STATUS ? Constants.ALREADY_EXISTED_PROBLEM_CODE : problem || 'unknown';
    yield put(createdSituation(undefined, error));
    throw new Error('create situation failed: ' + error);
  }
}

export function* updateSituationSaga({ payload }: UpdateSituationActionPayload) {
  const { updateSituationApi } = getAPI();
  const response: YieldOf<typeof updateSituationApi> = yield call(updateSituationApi, payload);
  const { data, ok, problem, status } = response;
  if (status === 401 || status === 403) {
    yield put(logout());
  }
  if (ok) {
    yield put(fetchSituations());
    yield put(updatedSituation(data));
    return data;
  } else {
    const error =
      status === Constants.ALREADY_EXISTED_STATUS ? Constants.ALREADY_EXISTED_PROBLEM_CODE : problem || 'unknown';
    yield put(updatedSituation(undefined, error));
    throw new Error('update prsituationofil failed: ' + error);
  }
}

export function* deleteSituationSaga({ meta: { id } }: DeleteSituationActionPayload) {
  const { deleteSituationApi } = getAPI();
  const response: YieldOf<typeof deleteSituationApi> = yield call(deleteSituationApi, id);
  const { ok, problem, status } = response;
  if (status === 401 || status === 403) {
    yield put(logout());
  }
  if (ok) {
    yield put(fetchSituations());
    yield put(deletedSituation(true));
  } else {
    const error = problem || 'unknown';
    yield put(deletedSituation(false, error));
  }
}

export default function* SituationSaga() {
  yield takeLatest(createSituation.type, sagaWithCallback(createSituationSaga));
  yield takeLatest(updateSituation.type, sagaWithCallback(updateSituationSaga));
  yield takeLatest(deleteSituation.type, deleteSituationSaga);
}
